{
  "search": "Ara",
  "searchWithin": "Şurada ara:"
}
